
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/privateAppsPanel/components/common/updateInProgressIndication/updateInProgressIndication.scss.css.virtualfile';
        module.exports = {"update-in-progress":"_update-in-progress_1nwd2_1","updateInProgress":"_update-in-progress_1nwd2_1"};